import { render, staticRenderFns } from "./IMultiPicker.vue?vue&type=template&id=0c2cc6f2&"
import script from "./IMultiPicker.vue?vue&type=script&lang=js&"
export * from "./IMultiPicker.vue?vue&type=script&lang=js&"
import style0 from "./IMultiPicker.vue?vue&type=style&index=0&id=0c2cc6f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports